import { fetchApi } from '../baseApi';
import { ConfirmIndentityRequest } from 'src/models/question';

export function submitConfirmIdentityAnswer(confirmIdentityAnswer: ConfirmIndentityRequest) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submit_confirm_identity_answers`, 'POST', confirmIdentityAnswer).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot submit confirm identity answers!'));
        });
    });
}

// New Step02
export function submitExperianQuestions(request: ConfirmIndentityRequest) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submit_experian_questions`, 'POST', request).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot submit experian questions!'));
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/experianQuestion/index.ts